<div id="droparea">
    Drop files here to upload
</div>
<div id='uploadFile'>
    <ejs-uploader 
        #defaultupload  
        [autoUpload]="false" 
        [dropArea]="dropEle"
        [asyncSettings]="uploadPaths"
        (success)="onUploadSuccess($event)"
        (failure)="onUploadFailure($event)"
        (uploading)="onFileUpload($event)">
    </ejs-uploader>
</div>